var render, staticRenderFns
import script from "./doctoralbum.vue?vue&type=script&lang=js"
export * from "./doctoralbum.vue?vue&type=script&lang=js"
import style0 from "./doctoralbum.vue?vue&type=style&index=0&id=595d8d9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595d8d9e",
  null
  
)

export default component.exports